export enum ApplicationTypes {
  PropertyValuation = "property-valuation",
  LeadCollector = "lead-collector",
  Form = "Form",
}
